import { ProductsFormGuard } from 'components/common-form/product-form-guard';
import { QuoteWorkspaceProvider } from 'contexts/quote-workspace.context';
import { FC } from 'react';

import { StaticQuotesWorkspace } from './StaticQuotesWorkspace';

export const StaticWorkspaceWrapper: FC = () => {
  return (
    <QuoteWorkspaceProvider value="static">
      <ProductsFormGuard>
        <StaticQuotesWorkspace />
      </ProductsFormGuard>
    </QuoteWorkspaceProvider>
  );
};
StaticWorkspaceWrapper.displayName = 'StaticWorkspaceWrapper';
